
import { defineComponent, ref, watch, nextTick } from 'vue'

export default defineComponent({
  name: 'HModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    transitionName: {
      type: String,
      default: 'h-modal'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    mask: {
      type: Boolean,
      default: true
    },
    closeOnClickMask: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    modalStyle: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['show', 'hide', 'update:visible', 'after-enter', 'after-leave'],
  setup(props, { emit }) {
    const modalRef = ref<HTMLElement | null>(null)

    watch(
      () => props.visible,
      (isShow) => {
        if (isShow) {
          nextTick(() => {
            if (modalRef.value) {
              modalRef.value.focus()
            }
            emit('show')
          })
        }
      }
    )

    function close() {
      emit('hide')
      emit('update:visible', false)
    }

    function onMaskClicked() {
      if (props.closeOnClickMask) {
        close()
      }
    }

    function onEscapePressed() {
      if (props.closeOnPressEscape) {
        close()
      }
    }

    function afterEnter() {
      emit('after-enter')
    }

    function afterLeave() {
      emit('after-leave')
    }

    return {
      modalRef,
      close,
      onMaskClicked,
      onEscapePressed,
      afterEnter,
      afterLeave
    }
  }
})
